@if (shipment.status !== 'assigned' && shipment.status !== 'confirmation pending') {
  <div class="banner-container">
    @if (isDocumentNameACI || isDocumentNameACE) {
      <div class="banner">
        <mat-icon svgIcon="files"></mat-icon>
        <span>eManifest Available</span>
      </div>
    }
  </div>
}
<div ngClass="item-container" data-test="item-container">
  <div (click)="goToShipmentMyDetails()">
    <div   class="header-row">
      <span class="shipment-id">{{ shipment.shipmentID }}</span>
      <span [ngClass]="[getStatusClass(), 'status-tag']" data-test="shipment-status">
        {{ shipment.status === 'out for delivery' ? 'In Transit' : (shipment.status | titlecase) }}
      </span>
    </div>
    @if (coDriverName) {
      <div   class="margin-top-sm">
        <span class="co-driver">Co-Driver</span>
        <span class="co-driver-name">{{ coDriverName }}</span>
      </div>
    }
    <div class="route-section margin-top-md">
      <div class="route-info">
        <div class="route-visual">
          <div class="route-point from-point">
            <mat-icon class="route-icon">radio_button_checked</mat-icon>
          </div>
          <div class="route-line"></div>
          <div class="route-point to-point">
            <mat-icon class="route-icon">location_on</mat-icon>
          </div>
        </div>
        <div class="route-addresses" (click)="openGoogleMapsDirections($event)">
          <div class="address-item from-address">
            <span class="address-label">From</span>
            <a class="address-text" appBlurElement>{{ pickupAddress.updatedPickupAddress }}</a>
            <span class="address-datetime">{{ pickupAddress.updatedPickupDate }}, {{ pickupAddress.updatedPickupTime }}</span>
          </div>
          <div class="address-item to-address">
            <span class="address-label">To</span>
            <a class="address-text" appBlurElement>{{ deliveryAddress?.updatedDeliveryAddress }}</a>
            <span class="address-datetime">{{ deliveryAddress.updatedDeliveryDate }}, {{ deliveryAddress.updatedDeliveryTime }}</span>
          </div>
        </div>
      </div>
      @if (shipment.rateVisibility !== false) {
        <div class="offer-rate">
          <span class="rate-amount">$ {{ shipment.offerRate }}</span>
          @if (shipment.rateCurrency) {
            <span class="currency-txt">{{ shipment.rateCurrency | uppercase }}</span>
          }
        </div>
      }
    </div>

    <div class="details-grid margin-top-lg">
      <div class="detail-item">
        <mat-icon class="detail-icon">local_shipping</mat-icon>
        <div class="detail-content">
          <span class="detail-title">Unit</span>
          <span class="detail-value">{{ mainUnitNumber || '-' }}</span>
        </div>
      </div>
      <div class="detail-item">
        <mat-icon class="detail-icon">rv_hookup</mat-icon>
        <div class="detail-content">
          <span class="detail-title">Trailer</span>
          <span class="detail-value">
            {{
            shipment.trailers
            ? shipment.trailers.length === 0
            ? '-'
            : shipment.trailers.length === 1
            ? shipment.trailers[0].unitNumber
            : '1+'
            : '-'
            }}
          </span>
        </div>
      </div>
      <div class="detail-item">
        <mat-icon class="detail-icon">inventory_2</mat-icon>
        <div class="detail-content">
          <span class="detail-title">Load Type</span>
          <span class="detail-value">{{ loadTypeMap[shipment.loadType] || '-' }}</span>
        </div>
      </div>
      <div class="detail-item">
        <mat-icon class="detail-icon">scale</mat-icon>
        <div class="detail-content">
          <span class="detail-title">Load Size</span>
          <span class="detail-value">{{ getLoad() }}</span>
        </div>
      </div>
      <div class="detail-item">
        <mat-icon class="detail-icon">straighten</mat-icon>
        <div class="detail-content">
          <span class="detail-title">Miles</span>
          <span class="detail-value">{{ shipment.distance ? shipment.distance + ' miles' : '-' }}</span>
        </div>
      </div>
      <div class="detail-item">
        <mat-icon class="detail-icon">route</mat-icon>
        <div class="detail-content">
          <span class="detail-title">DH-O/DH-D</span>
          <span class="detail-value">{{ getDeadhead() }}</span>
        </div>
      </div>
    </div>
  </div>
  @if (showConfirm()) {
    <div class="margin-top-md confirm-button-container">
      <button mat-flat-button class="btn-accept btn-confirm" (click)="confirmShipment()" data-test="confirm-button">
        <mat-icon>check_circle</mat-icon>
        Confirm
      </button>
    </div>
  }

  @if (showChangeStatus()) {
    <div>
      <div class="margin-top-md">
        <div class="action-buttons-container">
          @if (
            !(
            (shipment.status === 'pickup in progress' ||
            shipment.status === 'out for delivery' ||
            shipment.status === 'unloading') &&
            shipment.pickDropType === 'sequence'
            )
            ) {
            <button
              mat-flat-button
              class="btn-accept btn-status"
              (click)="onChangeShipmentStatus()"
              [disabled]="disableChangeStatus() || loading"
              data-test="change-status-button"
              >
              <mat-icon>update</mat-icon>
              Change Status
            </button>
          }
          @if (
            displayStopsFeatureButton && !shipmentHistory &&
            (shipment.status === 'pickup in progress' ||
            shipment.status === 'out for delivery' ||
            shipment.status === 'unloading') &&
            shipment.pickDropType === 'sequence'
            ) {
            <button
              mat-flat-button
              class="btn-accept btn-stops"
              (click)="goToShipmentsStops()"
              [disabled]="disableChangeStatus() || loading"
              data-test="stops-view-button"
              >
              <mat-icon>location_on</mat-icon>
              Stops ({{ this.statusComplete }}/{{ this.stops?.length || '0' }})
            </button>
          }
          <button
            mat-flat-button
            class="btn-accept btn-document"
            (click)="goToShipmentDocuments()"
            [disabled]="loading"
            data-test="document-button"
            >
            <mat-icon>description</mat-icon>
            Documents
          </button>
        </div>
      </div>
      <div class="margin-top-md contact-row">
        <div (click)="onAddShipmentComment()"><mat-icon svgIcon="comments" data-test="comments"></mat-icon></div>
        <div (click)="onAddShipmentPhoto()"><mat-icon svgIcon="camera" data-test="camera"></mat-icon></div>
        <div (click)="getContact()"><mat-icon svgIcon="phonecall" data-test="phonecall"></mat-icon></div>
        <div (click)="goToShipmentMyStatus()"><mat-icon svgIcon="history-line" data-test="status"></mat-icon></div>
      </div>
    </div>
  }
</div>
